import { makeStyles } from '@material-ui/core/styles';
import {
  XMEI_PRIMARY_COLOR,
  XMEI_SECONDARY_COLOR,
} from '../../../consts/common';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '90%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: '15px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
  },
  formControl: {
    margin: '6px 0',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  group: { display: 'flex', flex: 1 },
  formGroupTitle: {
    position: 'absolute',
    top: -10,
    left: 8,
    fontWeight: 600,
    padding: '0 4px',
    backgroundColor: theme.palette.background.paper,
  },
  formGroup: {
    position: 'relative',
    border: '1px solid ',
    borderRadius: 2,
    padding: '12px 12px 0 12px',
    margin: '24px 0 16px 0',
    '&:first-of-type': {
      marginTop: 16,
    },
  },
  mr16: {
    marginRight: '1.6em',
  },
  submit: {
    margin: theme.spacing(4, 0, 2),
    backgroundColor: XMEI_PRIMARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
  },
  confirm: {
    margin: theme.spacing(4, 0, 2),
    backgroundColor: XMEI_SECONDARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
    '&:hover': {
      backgroundColor: XMEI_PRIMARY_COLOR,
    },
  },
  cssOutlinedInput: {
    '&$cssFocused $notchedOutline': {
      borderColor: '#8d8d8e',
    },
  },
  cssFocused: {},
  notchedOutline: {},
  checkBoxText: {
    fontSize: 14,
    textAlign: 'justify',
    fontWeight: 'normal',
    color: '#000',
  },
  checkBoxTextContent: {
    fontSize: 16,
    textAlign: 'justify',
    fontWeight: 'bold',
    color: XMEI_PRIMARY_COLOR,
  },
  textFooter: {
    textAlign: 'justify',
    padding: 12,
    fontSize: 13,
  },
}));
